import {postTransportRequirement} from './api';
export const submitEnquiry=postTransportRequirement;
